/***********************************************************************************
 * Default layout for all views
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import config from '@/config/client';
import packageJson from '@root/package.json';

import '@/plugins/Vuetify';
import '@/plugins/Vuelidate';

@Component({
    computed: {
        ...mapGetters({
            env: 'getEnv',
            origin: 'getOrigin',
            closeButton: 'getCloseButton'
        })
    },
    metaInfo(): object {
        return {
            title: config.head.title,
            titleTemplate: `%s | ${config.head.title}`,
            meta: config.head.meta,
            link: config.head.link
        };
    }
})
class DefaultLayout extends Vue {
    private env!: string;
    private origin!: string;
    private closeButton!: boolean;

    /**
     * get environment label
     */
    private get envLabel(): string | undefined {
        return this.env !== 'prod' ? this.env : undefined;
    }

    /**
     * get current year
     */
    private get year(): number {
        return new Date().getFullYear();
    }

    /**
     * get current version
     */
    private get version(): string {
        return packageJson.version;
    }

    private close(): void {
        window.parent.postMessage(
            JSON.stringify({
                step: 'EXIT'
            }),
            this.origin
        );
    }
}

export default DefaultLayout;
